import Icon from "./icon.js";
import { post } from "./request.js";

const { redom } = window;
const { el, list, place } = redom;

export default class Reservations {
  constructor({ app, api, i18n, menu }) {
    this.menu = menu;
    this.app = app;
    this.api = api;
    this.i18n = i18n;
    this.el = el(
      ".reservations",
      (this.title = el("h2")),
      new AccordionHandler(),
      (this.upcomingReservationsTitle = el("h3")),
      el(
        ".menu-content",
        (this.noUpcomingReservations = place(
          (this.noUpcomingReservationsText = el("p"))
        )),
        (this.upcomingReservations = list(".reservations", Reservation, "_id", {
          app,
          api,
          i18n,
        }))
      ),
      new AccordionHandler(),
      (this.activeReservationsTitle = el("h3")),
      el(
        ".menu-content",
        (this.noActiveReservations = place(
          (this.noActiveReservationsText = el("p"))
        )),
        (this.activeReservations = list(".reservations", Reservation, "_id", {
          app,
          api,
          i18n,
        }))
      ),
      new AccordionHandler(),
      (this.pastReservationsTitle = el("h3")),
      el(
        ".menu-content",
        (this.noPastReservations = place(
          (this.noPastReservationsText = el("p"))
        )),
        (this.pastReservations = list(".reservations", Reservation, "_id", {
          app,
          api,
          i18n,
        }))
      ),
      new AccordionHandler(),
      (this.canceledReservationsTitle = el("h3")),
      el(
        ".menu-content",
        (this.noCanceledReservations = place(
          (this.noCanceledReservationsText = el("p"))
        )),
        (this.canceledReservations = list(".reservations", Reservation, "_id", {
          app,
          api,
          i18n,
        }))
      )
    );
  }

  onmount() {
    this.api.fetchReservations(true);
  }

  onunmount() {
    this.app.map.map.getSource("highlight").setData({
      type: "FeatureCollection",
      features: [],
    });
  }

  update({ reservations }) {
    const { i18n } = this;
    this.title.textContent = i18n("sections.reservations");
    this.upcomingReservationsTitle.textContent = i18n("reservations.upcoming");
    this.activeReservationsTitle.textContent = i18n("reservations.active");
    this.pastReservationsTitle.textContent = i18n("reservations.past");
    this.canceledReservationsTitle.textContent = i18n("reservations.canceled");
    this.noUpcomingReservationsText.textContent = i18n("reservations.empty");
    this.noActiveReservationsText.textContent = i18n("reservations.empty");
    this.noPastReservationsText.textContent = i18n("reservations.empty");
    this.noCanceledReservationsText.textContent = i18n("reservations.empty");

    const upcomingReservations = reservations.filter(
      (reservation) => reservation.upcoming
    );
    const activeReservations = reservations.filter(
      (reservation) => reservation.active
    );
    const pastReservations = reservations.filter(
      (reservation) => reservation.past
    );
    const canceledReservations = reservations.filter(
      (reservation) => reservation.canceled
    );

    this.noUpcomingReservations.update(!upcomingReservations.length);
    this.noActiveReservations.update(!activeReservations.length);
    this.noPastReservations.update(!pastReservations.length);
    this.noCanceledReservations.update(!canceledReservations.length);

    this.upcomingReservations.update(upcomingReservations);
    this.activeReservations.update(activeReservations);
    this.pastReservations.update(pastReservations);
    this.canceledReservations.update(canceledReservations);
  }
}

class Reservation {
  constructor({ app, api, i18n }) {
    this.i18n = i18n;
    this.app = app;
    this.api = api;
    this.el = el(
      ".reservation",
      (this.date = el("p.date")),
      el(
        "p.meta",
        (this.natureOfOperation = el("span")),
        " | ",
        (this.activitytype = el("span"))
      ),
      el("br"),
      (this.cancel = el("button.button.red"))
    );
  }

  update(data) {
    const { i18n } = this;
    const {
      _id,
      startDatetime,
      endDatetime,
      natureOfOperation,
      activitytype,
      bounds,
      geometry,
      active,
      past,
      canceled,
    } = data;
    const { HOST } = window.ENV;

    this.cancel.textContent = active ? i18n("end") : i18n("cancel");

    this.cancel.style.display = past || canceled ? "none" : "";
    this.cancel.onclick = async () => {
      await post(`${HOST}utm/reservation/${_id}/cancel`);
      this.api.fetchReservations(true);
    };

    this.date.textContent = humanDate(new Date(startDatetime));
    this.natureOfOperation.textContent = natureOfOperation;
    this.activitytype.textContent = activitytype;
    this.el.onclick = () => {
      const highlight = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry,
          },
        ],
      };
      this.app.map.map.getSource("highlight").setData(highlight);
      this.app.map.map.fitBounds(bounds, {
        padding: {
          top: 16,
          left: 16,
          right: 16,
          bottom: 16,
        },
        animate: true,
        duration: 2000,
      });
    };
  }
}

export function humanDate(date) {
  const d = date.getDate();
  const m = date.getMonth() + 1;
  const y = date.getFullYear();
  return `${d}.${m}.${y}`;
}

export function humanTime(date) {
  const h = date.getHours();
  const min = date.getMinutes();
  return `${pad(h)}:${pad(min)}`;
}

function pad(val) {
  return `0${val}`.slice(-2);
}

class AccordionHandler {
  constructor() {
    this.el = new Icon("circle-chevron-down", { class: "accordion-handler" });
    this.opened = true;
  }

  onmount() {
    this.el.el.onclick = this.el.el.nextSibling.onclick = () => {
      this.opened = !this.opened;

      if (this.opened) {
        this.el.update("circle-chevron-down");
        this.el.el.nextSibling.nextSibling.style.display = "";
      } else {
        this.el.update("circle-chevron-right");
        this.el.el.nextSibling.nextSibling.style.display = "none";
      }
    };
  }
}
